export default __webpack_public_path__ + "asset/img/quote-left~f8491819.png";